<script>
import VDataTableCustom from "@/components/VDataTable/VDataTableCustom.vue";

export default {
    name: "VDataTableCompanies",
    components: {VDataTableCustom},
    inheritAttrs: false,
    data() {
        return {
            headers: [
                {
                    text: 'Компания',
                    align: 'start',
                    sortable: true,
                    value: 'name',
                },
            ],
        };
    },
}
</script>

<template>
    <v-data-table-custom
        v-bind="$attrs"
        v-on="$listeners"
        :headers="headers"
        item-key="id"
        permissions-by-module="users"
    >
    </v-data-table-custom>
</template>

<style scoped lang="scss">

</style>
